import '../styles/Rdashboard.css';
import { useNavigate } from 'react-router-dom';

const Card = ({ label, labelIcon, background, data, columns, redirectTo, loading }) => {
  const topFive = (data ?? []).slice(0, 5); // Limit to 5 rows
  const navigate = useNavigate();

  return (
    <div className="r-card" style={{ backgroundColor: background }}>
      <div className="r-card-header">
        <h2><i className={`${labelIcon} mr-1 text-[17px]`} /> {label}</h2>
        {redirectTo && (
          <button className="r-card-redirect" onClick={() => navigate(redirectTo)}>
            <i className="fa-solid fa-arrow-up-right-from-square"></i>
          </button>
        )}
      </div>
      <div className="r-card-content">
        {loading ? (
          <div className="loading-state">Loading...</div>
        ) : topFive.length > 0 ? (
          <table className="r-card-table">
            <thead>
              <tr>
                {columns.map((col, index) => (
                  <th key={index} style={{ width: col.width }}>{col.label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {topFive.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {columns.map((col, colIndex) => (
                    <td key={colIndex}>
                      {typeof col.accessor === 'function'
                        ? col.accessor(row)
                        : row[col.accessor]}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="no-data">No data available</div>
        )}
      </div>
    </div>
  );
};

export default Card;
